module.exports = __webpack_public_path__ + "static/media/hero.b12ac70c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/projects/hall-farm-threshing-barn/hero.jpg
// module id = 58
// module chunks = 0